import type { GetShipmentsParams } from '@uturn/api/v2';
import { createContext } from 'react';

export const FilterContext = createContext<{
	filters: Partial<GetShipmentsParams>;
	setFilters: (filterChanges: Partial<GetShipmentsParams>) => void;
}>({ filters: {}, setFilters: () => {} });
